/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BasePercentiles } from '../models/BasePercentiles';
import type { TargetPercentile } from '../models/TargetPercentile';
import type { TargetPercentileFilter } from '../models/TargetPercentileFilter';
import type { TypeOfPay } from '../models/TypeOfPay';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TargetPercentileService {

    /**
     * Export target percentiles
     * @returns any Success
     * @throws ApiError
     */
    public static exportTargetPercentiles({
        requestBody,
    }: {
        requestBody: TargetPercentileFilter,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/percentile/export',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get company jobs with target percentiles
     * @returns any[] Success
     * @throws ApiError
     */
    public static getTargetPercentiles({
        requestBody,
    }: {
        requestBody: (TargetPercentileFilter & {
            limit?: number;
            offset?: number;
        }),
    }): CancelablePromise<any[]> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/percentile',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update Target Percentiles For a Plan+CompanyJob+Paymarket
     * @returns TargetPercentile Success
     * @throws ApiError
     */
    public static updateTargetPercentile({
        requestBody,
    }: {
        requestBody: {
            filter: TargetPercentileFilter;
            typeOfPay: TypeOfPay;
            percentile?: BasePercentiles;
        },
    }): CancelablePromise<TargetPercentile> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/percentile',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
